import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/unit-sell-bys/new/loading';

export const Route = createFileRoute('/_private/settings/unit-sell-bys/new')({
  component: Loading,
});
